import { Separator, Wrapper } from './SectionSeparator.style'

const SectionSeparator: React.FC = () => (
  <Wrapper>
    <Separator />
  </Wrapper>
)

export default SectionSeparator
